export const LOAD_SAVED_MAPPINGS: string = 'LOAD_SAVED_MAPPINGS';
export const SAVE_MODEL_API_REQUEST: string = 'SAVE_MODEL_API_REQUEST';
export const ADD_SAVED_STORE_MAPPING: string = 'ADD_SAVED_STORE_MAPPING';
export const UNSAVE_MODEL_API_REQUEST: string = 'UNSAVE_MODEL_API_REQUEST';
export const REMOVE_SAVED_STORE_MAPPING: string = 'REMOVE_SAVED_STORE_MAPPING';
export const REMOVE_SAVED_STORE_MAPPINGS: string = 'REMOVE_SAVED_STORE_MAPPINGS';
export interface LoadSavedMappings {
	readonly type: 'LOAD_SAVED_MAPPINGS';
	readonly savedPortfolioMapping: Map<string, string>;
}

export interface SaveModelApiRequest {
	readonly type: 'SAVE_MODEL_API_REQUEST';
	readonly portfolioId: string;
	readonly origin: string;
}

export interface AddSavedStoreMapping {
	readonly type: 'ADD_SAVED_STORE_MAPPING';
	readonly newMapping: Map<string, string>;
}

export interface UnsaveModelApiRequest {
	readonly type: 'UNSAVE_MODEL_API_REQUEST';
	readonly portfolioId: string;
	readonly origin: string;
}

export interface RemoveSavedStoreMapping {
	readonly type: 'REMOVE_SAVED_STORE_MAPPING';
	readonly portfolioId: string;
}

export interface RemoveSavedStoreMappings {
	readonly type: 'REMOVE_SAVED_STORE_MAPPINGS';
	readonly portfolioIds: string[];
}

export type SavedModelPortfoliosAction = LoadSavedMappings | SaveModelApiRequest | AddSavedStoreMapping | UnsaveModelApiRequest | RemoveSavedStoreMapping | RemoveSavedStoreMappings;
